import { render, staticRenderFns } from "./soft.vue?vue&type=template&id=56dd9076"
import script from "./soft.vue?vue&type=script&lang=js"
export * from "./soft.vue?vue&type=script&lang=js"
import style0 from "./soft.vue?vue&type=style&index=0&id=56dd9076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports